// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"intl-relativetimeformat":"6afbe37423fea42c590d","vendors-node_modules_formatjs_intl-getcanonicallocales_polyfill_js-node_modules_formatjs_intl-64af64":"bda0bcded679958c5ce0","polyfills":"1f540d3205bb73facedc"}[chunkId] + ".js";
};